export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  // The server refused a label change on a conversation (no conversation_label_manage).
  CONVERSATION_LABELS_FORBIDDEN: 'CONVERSATION_LABELS_FORBIDDEN',
  // Fired when any websocket event is received (heartbeat for staleness detection)
  WEBSOCKET_EVENT_RECEIVED: 'WEBSOCKET_EVENT_RECEIVED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  // Sidebar unread count refresh
  REFRESH_SIDEBAR_UNREAD_COUNTS: 'REFRESH_SIDEBAR_UNREAD_COUNTS',
  // Fired when the conversation the user currently has open is removed from the
  // active list (e.g. resolved while viewing a Wlab AI Agent pending list), so
  // the view can navigate back to the list and avoid stale/undefined references.
  CURRENT_CONVERSATION_REMOVED: 'CURRENT_CONVERSATION_REMOVED',
};
